import { IPFS_GATEWAY_PREFIX } from "../constants";

// Matches any http(s) IPFS gateway URL, e.g. https://ipfs.io/ipfs/<cid>
// Older minted metadata embeds full ipfs.io URLs; ipfs.io now sits behind a
// Cloudflare bot challenge that breaks browser fetches, so every IPFS URL
// must be rewritten to the configured gateway before use.
const HTTP_GATEWAY_PATTERN = /^https?:\/\/[^/]+\/ipfs\//;
const IPFS_SCHEME = "ipfs://";

export const toGatewayUrl = (uri: string): string => {
    if (!uri) return uri;
    if (uri.startsWith(IPFS_SCHEME)) {
        return IPFS_GATEWAY_PREFIX + uri.slice(IPFS_SCHEME.length);
    }
    const match = uri.match(HTTP_GATEWAY_PATTERN);
    if (match) {
        return IPFS_GATEWAY_PREFIX + uri.slice(match[0].length);
    }
    return uri;
};
